<template>
<!--  @contextmenu.prevent=""-->

  <div id="app" @contextmenu.prevent="">
      <app-header  v-if="$route.meta.keep"></app-header>
        <router-view></router-view>
  </div>
</template>
<script>
    document.addEventListener('DOMMouseScroll', function (event) {
        if (event.ctrlKey === true || event.metaKey) {
            event.preventDefault();
        }
    }, false);

    document.addEventListener('mousewheel', function (event) {
        if (event.ctrlKey === true || event.metaKey) {
            event.preventDefault();
        }
    }, false);
</script>
<script>
    import Header from '@/components/head/Index'
    import {GetListByData,GetInstPath} from '@/api/institution'
    import {mapGetters,mapState} from 'vuex'
  export default {
      name:'App',
      data(){
          return {
              header_show:true,
              path:true,
          }
      },
    computed:{
      ...mapGetters(['userinfo','inst_id']),
    },
      components:{
          'app-header':Header,
      },
    watch:{
      $route(to,from){
        if(to.path==='/login'){
          this.path=false
        }
      }
    },
      mounted() {
          localStorage.setItem('inst_id', 25)
          // if(window.name==''){
          //     console.log("页面首次加载")
          //     let path = window.location.href
          //     GetInstPath(path).then(res=>{
          //         if(res.data!==null){
          //             this.$store.dispatch('user/SET_InstId',res.data );
          //             localStorage.setItem('inst_id', res.data)
          //             this.$router.push({
          //                 path: '/home'
          //             })
          //         }
          //         window.name = "isReload"
          //     })
          // }
          // else if(window.name = 'isReload') {
          //     console.log("页面被刷新")
          // }
      },
      created() {

      if (localStorage.getItem("inst_id")&&localStorage.getItem("inst_id")!==null) {
          this.$store.dispatch('user/SET_InstId', localStorage.getItem("inst_id"));//当页面刷新时把缓存数据赋值给vuex
      }
      if (localStorage.getItem("userinfo")&&localStorage.getItem("userinfo")!==null) {
       this.$store.dispatch('user/SETUserInfo', localStorage.getItem("userinfo"));//当页面刷新时把缓存数据赋值给vuex
      }
      else {
          this.$store.dispatch('user/SETUserInfo', null);//当页面刷新时把缓存数据赋值给vuex
          localStorage.setItem('userinfo', null)
          window.location.reload();
      }
    },
    methods:{
          //是否显示头部
          header(bool) {
              this.header_show = bool;
          },
      }
  }
</script>

<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    margin: 0;
    padding: 0;
    font-size: 15px;
  }
  body{
    margin: 0;
  }
</style>
